<template>
  <v-container
    v-if="company"
    class="layout-container pa-0"
  >
    <ContactSettings
      :settings="settings"
      :company="company"
    />

    <Feature
      v-slot="{ feature }"
      :feature-slug="featureNames.COMPANY"
    >
      <div v-if="feature.config.isAiSettingsVisible">
        <v-divider class="my-4" />
        <AiSettings
          :settings="settings"
          :company="company"
          :showUpselling="!feature.config.isMetaCompanyDataEditable"
          class="my-4"
        />
      </div>
    </Feature>

    <Feature :feature-slug="featureNames.LANDINGPAGE">
      <div>
        <v-divider class="my-4" />
        <WebSettings
          v-if="settings"
          :settings="settings"
          :company="company"
          class="my-4"
        />
      </div>
    </Feature>

    <Feature :feature-slug="featureNames.LANDINGPAGE">
      <div>
        <v-divider class="my-4" />
        <ImageSettings :company="company" />
      </div>
    </Feature>

    <Feature
      v-slot="{ feature }"
      :feature-slug="featureNames.COMPANY"
    >
      <v-divider class="my-4" />
      <!-- TODO: bring the color settings -->
      <ColorSettings
        :company="company"
        :showUpselling="!feature.config.isColorEditable"
      />
    </Feature>

    <Feature
      v-slot="{ feature }"
      :feature-slug="featureNames.COMPANY"
    >
      <v-divider class="my-4" />
      <LanguageSettings
        :company-locale="company.locale"
        :showUpselling="!feature.config.isCompanyLanguageEditable"
      />
    </Feature>

    <Feature
      v-slot="{ feature }"
      :feature-slug="featureNames.COMPANY"
    >
      <v-divider class="my-4" />

      <OtherSettings
        :company="company"
        :showUpselling="!feature.config.isOtherCompanyDataEditable"
      />
    </Feature>
  </v-container>
</template>

<script>
import { ref } from 'vue'

import { useAiAgent } from '@/composables/useAiAgent'
import { SETTINGS_AGENT_ID } from '@/lib/ai/agents/settingsAgent'
import featureMixin from '@/mixins/feature'

import AiSettings from './AiSettings.vue'
import ColorSettings from './ColorSettings.vue'
import { useSettingsAiActionHandler } from './composables/useSettingsAiActionHandler'
import { useSettingsAiContext } from './composables/useSettingsAiContext'
import ContactSettings from './ContactSettings.vue'
import ImageSettings from './ImageSettings.vue'
import LanguageSettings from './LanguageSettings.vue'
import OtherSettings from './OtherSettings.vue'
import COMPANY from './queries/CompanyData.gql'
import SETTINGS from './queries/Settings.gql'
import WebSettings from './WebSettings.vue'

export default {
  components: {
    LanguageSettings,
    ContactSettings,
    WebSettings,
    AiSettings,
    ImageSettings,
    ColorSettings,
    OtherSettings,
  },
  mixins: [featureMixin],
  setup() {
    const companyRef = ref(null)

    const { contextLoader, syncContext } = useSettingsAiContext({ companyRef })

    useAiAgent(SETTINGS_AGENT_ID)

    useSettingsAiActionHandler({
      companyRef,
      onMutationSuccess: syncContext,
    })

    // Eagerly sync context so the drawer has data before the first message
    contextLoader()

    return { companyRef, syncContext }
  },
  watch: {
    // Keep companyRef in sync with the Apollo result so AI composables see fresh data
    company(val) {
      this.companyRef = val
      this.syncContext()
    },
  },
  methods: {
    async updateCompanyLocale() {
      await this.$apollo.queries.company.refetch()
    },
  },
  apollo: {
    settings: {
      query: SETTINGS,
      variables() {
        return {
          companyId: this.$auth.user.companyId,
        }
      },
    },
    company: {
      query: COMPANY,
      variables() {
        return {
          id: this.$auth.user.companyId,
        }
      },
      update: ({ company }) => {
        return {
          ...company,
          images: {
            ...company.images,
            logo: company.images.logo || {},
            team: company.images.team || {},
            region: company.images.region || {},
            lpValuationHero: company.images.lpValuationHero || {},
          },
          ambassador: {
            ...company.ambassador,
            image: company.ambassador.image || {},
          },
        }
      },
      result({ data }) {
        if (data?.company) {
          this.companyRef = data.company
        }
      },
    },
  },
}
</script>
